export const QiagenManagerDefaultData = {
    sampleDate: null,
    sampleName: []
}